<template>
  <div>
    <div class="heading-4 font-weight-medium">{{ title }}</div>
    <div
      class="text-5 darkgray--text smoke rounded-10 pa-3 mt-3"
      v-if="description"
    >
      {{ description }}
    </div>
    <div class="mt-8">
      <div class="d-flex align-center">
        <div class="flex-2 gray--text text-5 font-weight-medium">VAULT:</div>
        <div class="flex-3 text-3">{{ vault }}-{{token | uppercase}}</div>
      </div>
      <div class="d-flex align-center mt-3">
        <div class="flex-2 gray--text text-5 font-weight-medium">AMOUNT:</div>
        <div class="flex-3 text-3 text-uppercase">
          {{ txPayload.amount | denomFormat }}
          <span class="gray--text">{{ token }}</span>
        </div>
      </div>
      <div class="d-flex align-center mt-3">
        <div class="flex-2 gray--text text-5 font-weight-medium">
          TRANSACTION FEE:
        </div>
        <div class="flex-3 text-3">
          {{ txFees.amount | denomFormat }} <span class="gray--text">ETH</span>
        </div>
      </div>
    </div>
    <div class="mt-8 text-6 darkgray--text smoke rounded-10 pa-5">
      By confirming, you will be required to sign this transaction.
    </div>
    <div class="mt-10 d-flex align-center justify-end">
      <div
        class="text-4 font-weight-medium gray--text clickable"
        @click="$emit('close')"
      >
        Cancel
      </div>
      <c-btn class="ml-5" @click="confirm" :disabled="!txObject || shouldShowTx"
        >Confirm</c-btn
      >
    </div>
    <sign-tx
      v-if="shouldShowTx"
      :txObject="txObject"
      :txType="txType"
      :vault="vault"
      :vaultToken="vaultToken"
      :metadata="metadata"
      @onError="onError"
      @onSuccess="onSuccess"
      @cancel="$emit('close')"
    />
  </div>
</template>

<script>
import SignTx from "./SignTx";

export default {
  components: {
    SignTx,
  },
  props: [
    "title",
    "description",
    "vault",
    "vaultToken",
    "token",
    "txPayload",
    "txObject",
    "value",
    "txType",
    "txFees",
    "metadata",
  ],
  data: () => ({
    shouldShowTx: false,
  }),
  methods: {
    onError(error) {
      this.$emit("onError", error);
    },
    onSuccess(data) {
      this.$emit("onSuccess", data);
    },
    confirm() {
      this.shouldShowTx = true;
    },
  },
  watch: {
    value: {
      immediate: true,
      async handler() {
        this.shouldShowTx = false;
      },
    },
  },
};
</script>
